const styles = theme => ({
  container: {
    padding: '20px',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    background: theme.palette.primary.white,
  },
  main: {
    overflow: 'hidden',
    background: 'none',
    borderRadius: '0px',
  },
  titleHead: {
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '16px 0px',
    background: 'transparent',
    [theme.breakpoints.up('md')]: {
      // borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      fontSize: '20px',
      // '& $dangerText': {
      //     color: '#D2374F',
      // },
    },
  },
  title: {
    fontWeight: '600',
    marginBottom: '5px',
  },
  large: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    marginBottom: '10px',
  },
  propertyName: {
    color: theme.palette.primary.dim,
    fontSize: '16px',
  },
  propertyValue: {
    color: theme.palette.primary.ascent,
    fontSize: '18px',
    fontWeight: 600,
  },
  viewmoreHolder: {
    borderTop: '1px solid #EBEEF3',
    padding: '16px 10px',
    textAlign: 'center',
    color: theme.palette.primary.main,
    '& a': {
      color: theme.palette.primary.main,
    },
  },
  '@media (max-width: 767px)': {
    propertyName: {
      fontSize: '12px',
      fontWeight: 400,
    },
    propertyValue: {
      fontSize: '12px',
      fontWeight: 500,
    },
  },
  fullShare: {
    color: theme.palette.primary.black100,
    fontSize: '18px',
    fontWeight: '800',
  },
});

export default styles;
// paperCardFrame
// accordionDetailsItemContainer
